import { LoginRequest, LoginResponse, Schedule, ScheduleResponse } from '../types/schedule';
import { Notice, NewNotice, NoticeResponse, NoticeListResponse } from '../types/notice';

const API_BASE_URL = 'https://visit.dongan.net/api'; // 백엔드 API 엔드포인트
//const API_BASE_URL = 'http://localhost:3001'; // Change this to your actual backend URL

// Helper function for API requests
async function fetchApi<T>(endpoint: string, method: string = 'GET', data?: any): Promise<T> {
  const options: RequestInit = {
    method,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  if (data) {
    options.body = JSON.stringify(data);
  }

  const response = await fetch(`${API_BASE_URL}${endpoint}`, options);
  const result = await response.json();
  return result as T;
}

// Login API
export const login = (data: LoginRequest): Promise<LoginResponse> => {
  return fetchApi<LoginResponse>('/login', 'POST', data);
};

// Schedule APIs
export const getSchedules = (): Promise<Schedule[]> => {
  return fetchApi<Schedule[]>('/schedules');
};

export const createSchedule = (data: Schedule): Promise<ScheduleResponse> => {
  return fetchApi<ScheduleResponse>('/schedules', 'POST', data);
};

export const updateSchedule = (
  id: number,
  data: {
    content: string;
    end_date?: string | null;
    password: string;
    category: '교역자' | '목자' | '기타';
  }
): Promise<ScheduleResponse> => {
  return fetchApi<ScheduleResponse>(`/schedules/${id}`, 'PUT', data);
};

export const deleteSchedule = (
  id: number,
  data: { password: string }
): Promise<ScheduleResponse> => {
  return fetchApi<ScheduleResponse>(`/schedules/${id}`, 'DELETE', data);
};

// Notice APIs
export const getNotices = (page: number = 1, limit: number = 10): Promise<NoticeListResponse> => {
  return fetchApi<NoticeListResponse>(`/notices?page=${page}&limit=${limit}`);
};

export const getNoticeDetail = (id: number): Promise<NoticeResponse> => {
  return fetchApi<NoticeResponse>(`/notices/${id}`);
};

export const createNotice = (notice: NewNotice): Promise<NoticeResponse> => {
  return fetchApi<NoticeResponse>('/notices', 'POST', notice);
};

export const updateNotice = (
  id: number,
  data: { title: string; content: string; password: string }
): Promise<NoticeResponse> => {
  return fetchApi<NoticeResponse>(`/notices/${id}`, 'PUT', data);
};

export const deleteNotice = (id: number, data: { password: string }): Promise<NoticeResponse> => {
  return fetchApi<NoticeResponse>(`/notices/${id}`, 'DELETE', data);
};
